import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  :root {
    --primary-brand-darkest: #6a332f;
    --primary-brand-darker: #a14b45;
    --primary-brand-dark: #c35a52;
    --primary-brand-main: #fa7268;
    --primary-brand-light: #f7857a;
    --primary-brand-lighter: #f5988c;
    --primary-brand-lightest: #f2a599;
    --primary-brand-pastel: #ebd7c8;
    /* --primary-brand-faded: na; */

    --secondary-brand-darkest: #142723;
    --secondary-brand-darker: #0d3e34;
    --secondary-brand-dark: #084c3e;
    --secondary-brand-main: #00614d;
    --secondary-brand-light: #2b7d6a;
    --secondary-brand-lighter: #4d9481;
    --secondary-brand-lightest: #77af9c;
    --secondary-brand-pastel: #d7fff1;
    /* --secondary-brand-faded: na; */

    --header-font-family: "norfolk";
  }

  html, body {
    padding:0;
    margin:0;
    font-size: 16px;
  }
  body {
    color: #4A4A4A;
    font-family: 'normal-light', sans-serif;
    font-weight: normal;
    overflow-x: hidden;
  }
  h1 {
    font-family: 'norfolk', serif;
    font-weight: normal;
  }
  strong,
  h2,
  h3,
  h4,
  h5,
  h5 {
    font-family: 'normal-extrabold', avenir, sans-serif;
    font-weight: normal;
  }
  * {
    box-sizing: border-box;
  }
  /* Hack to get image gallery displaying over the rest of the content */
  /* TODO: This should be able to done through the component, investigate this: http://jossmac.github.io/react-images/#/styles */
  .react-images__positioner,
  .react-images__blanket {
    z-index: 999!important;
  }
  .react-images__container {
    height: auto!important;
  }
`;

export const C = styled.div`
  margin: 0;
  min-height: 100vh;
`;

export const Container = ({ children, ...props }) => {
  return (
    <C {...props}>
      <GlobalStyle />
      {children}
    </C>
  );
};

export const ContainerInner = styled.div`
  background: ${p => p.theme.background};
  font-size: 15px;
  line-height: 1.42;
  margin: 0 auto;
  position: relative;
  width: 100%;

  @media (min-width: 768px) {
    font-size: 16px;
    width: 767px;
  }

  @media (min-width: 1120px) {
    font-size: 19px;
    width: 1119px;
  }
`;
